import { render, staticRenderFns } from "./TabDelivery.vue?vue&type=template&id=d38fad7a&scoped=true&"
import script from "./TabDelivery.vue?vue&type=script&lang=js&"
export * from "./TabDelivery.vue?vue&type=script&lang=js&"
import style0 from "./TabDelivery.vue?vue&type=style&index=0&id=d38fad7a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d38fad7a",
  null
  
)

export default component.exports